import api from "./api";
import {CheckIn} from "../types/route";


export async function postAddCheckIn(data:CheckIn) {
    const response = await api.post("/checkin",data);
    return response;

}